import './App.css';
import React, { Component, useEffect, useState } from 'react'
import Amplify, {Auth, API, graphqlOperation, Storage } from 'aws-amplify'
import { createSlideshow } from './graphql/mutations'
import { listSlideshows } from './graphql/queries'
import { withAuthenticator } from '@aws-amplify/ui-react'
import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import Home from './components/Home';
import User from './components/UserPage';
import Screenshare from './components/Screenshare';
import Edit from './components/EditSlideshows.js'


class App extends React.Component {
  constructor(){
    super();
    this.state = {
      
    };
    
  }
  

  render(){
    return (
      <div className="App">
        <header className="App-header">
          <BrowserRouter>
            <div>
              <Switch>
                <Route path="/" component={Home} exact/>
                <Route path="/user" component={User}/>
                <Route path="/screenshare" component={Screenshare}/>
                <Route path='/edit' render={(props) => (<Edit {...props}/>)}/>
              </Switch>
            </div>
          </BrowserRouter>
        </header>
      </div>
    );
  }
}

export default App;
